import httpService from '@/core/services/http.service.js';
import subjectMapper from '@/core/services/helpers/subjectMapper.js';

// action types
export const GET_SUBJECTS = 'getSubjects';
export const GET_SUBJECTS_OPTIONS = 'getSubjectsOptions';

// mutations types
export const SET_SUBJECTS = 'setSubjects';
export const SET_SUBJECTS_META = 'setSubjectsMeta';
export const SET_SUBJECTS_OPTIONS = 'setSubjectsOptions';


const state = {
  subjects: [],
  subjectsAsOptions: [],
  meta: {},
};

const getters = {
  allSubjects: (state) => state.subjects,
  subjectsAsOptions: (state) => state.subjectsAsOptions,
  subjectsMeta: (state) => state.meta,
};

const actions = {
  [GET_SUBJECTS](context, { pageNumber = 1, perPage = 10, search = ''}) {
    httpService.get(`/api/b2b/subjects?page=${pageNumber}&per_page=${perPage}&search=${search}`).then((response) => {
      context.commit(SET_SUBJECTS, response.data.data);
      context.commit(SET_SUBJECTS_META, response.data.meta);
    });
  },
  [GET_SUBJECTS_OPTIONS](context) {
    httpService.get(`/api/b2b/subjects/options`).then((response) => {
      context.commit(SET_SUBJECTS_OPTIONS, response.data);
    });
  },
};

const mutations = {
  [SET_SUBJECTS](state, data) {
    state.subjects = subjectMapper.mapSubjects(data);
  },
  [SET_SUBJECTS_META](state, meta) {
    state.meta = meta;
  },
  [SET_SUBJECTS_OPTIONS](state, data) {
    state.subjectsAsOptions = subjectMapper.mapSubjectsAsOptions(data);
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
